var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.is_sms_selected && _vm.msg.length > 1)?_c('div',{staticClass:"text-left"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.checkSmsSenderName())}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }